import Reflux from "reflux";

export const ActionsMediaAssetsLab = Reflux.createActions({
  toggleModal: {},
  changePreviewInputProps: {},
  setPreviewInputPropsEdited: {},
  setEditedCampaignId: {},
  constructTemplateInputProps: {},
  changeTemplateInputProps: {},
  changeLabProps: {},
  selectTemplate: {},
  selectImage: {},
  selectLogo: {},
  setCompanyLogo: {},
  selectPreviewSelectedAsset: {},
  setDefaultDraftImages: {},
  generateMediaAssets: { asyncResult: true },
  generateMediaAssetsTextStream: { asyncResult: true },
  getCloudinaryImages: { asyncResult: true },
  updateCloudinaryMetadataCampaignId: { asyncResult: true },
  getAssetsByCampaignId: { asyncResult: true }
});
